/* Dream High draft navigation refinement. Intentionally isolated from product purchasing. */
(() => {
  const init = () => {
    const header = document.querySelector('.header-section');
    const collectionPath = '/collections/all';
    const storageKey = 'dhi-edition-0000-scroll';
    const isCollection = location.pathname.replace(/\/$/, '') === collectionPath;
    const crumbs = document.querySelector('.dhi-product__crumbs a[href="/collections/all"]');

    // Provide a contextual return within the approved existing breadcrumb.
    if (crumbs) {
      crumbs.textContent = 'Edition 00:00';
      crumbs.style.textDecoration = 'underline';
      crumbs.style.textUnderlineOffset = '3px';
      crumbs.addEventListener('click', (event) => {
        let previous;
        try { previous = new URL(document.referrer); } catch (_) {}
        if (previous && previous.origin === location.origin &&
            previous.pathname.replace(/\/$/, '') === collectionPath &&
            history.length > 1) {
          event.preventDefault();
          history.back();
        }
      });
    }

    // Preserve the exact browsing location when using the collection-to-product journey.
    if (isCollection) {
      const save = () => {
        try { sessionStorage.setItem(storageKey, JSON.stringify({ y: scrollY, t: Date.now() })); } catch (_) {}
      };
      document.addEventListener('click', (event) => {
        if (event.target.closest('a[href^="/pages/"], a[href^="/products/"]')) save();
      }, { passive: true });
      window.addEventListener('pagehide', save, { passive: true });
      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        // The browser restores scroll naturally with its back-forward cache.
      });
    }

    // Upward browsing should expose the navigation, including near the footer.
    if (header) {
      const style = document.createElement('style');
      style.textContent = '.header-section.dhi-nav-return-visible{transform:translateY(0)!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important}';
      document.head.appendChild(style);
      let lastY = scrollY;
      let lastTouchY = null;
      const show = () => header.classList.add('dhi-nav-return-visible');
      const hide = () => header.classList.remove('dhi-nav-return-visible');
      window.addEventListener('touchstart', e => { lastTouchY = e.touches[0]?.clientY ?? null; }, { passive:true });
      window.addEventListener('touchmove', e => {
        if (lastTouchY == null) return;
        const next = e.touches[0]?.clientY ?? lastTouchY;
        if (next > lastTouchY + 5 && scrollY > 80) show();
        else if (next < lastTouchY - 5) hide();
        lastTouchY = next;
      }, { passive:true });
      window.addEventListener('scroll', () => {
        const y = scrollY;
        if (y < lastY - 4 && y > 80) show();
        if (y > lastY + 4 || y < 60) hide();
        lastY = y;
      }, { passive:true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();